import React from "react";
import {
  Box,
  Typography,
  Stack,
  Grid,
} from "@mui/material";
import {
  AutoAwesome as SparkleIcon,
  Bolt as InstantIcon,
  CheckCircle as VerifiedIcon,
} from "@mui/icons-material";
import { colors, borderRadiusPx } from "../../../../../theme";
import { Path, DEFAULT_CURRENCY } from "../../../../../static/Constants";
import { CommonChip, CommonBreadcrumbs } from "../../../../Components/ui";
import { TbSquareRoundedNumber7Filled } from "react-icons/tb";

const SlotHeroBanner = ({
  totalActive = 0,
  combinedPrize = "0.00",
  currency = DEFAULT_CURRENCY,
}) => {
  return (
    <Box sx={{ mb: 4 }}>


      {/* Hero Banner Box */}
      <Box className="slot-hero-banner" sx={{ p: { xs: 3, md: 4 } }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={7}>
            <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 1.5 }}>
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: borderRadiusPx.md,
                  bgcolor: colors.primary.lighter,
                  color: colors.primary.main,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 2px 8px rgba(37, 99, 235, 0.15)",
                }}
              >
                <TbSquareRoundedNumber7Filled size={26} />
              </Box>
              <Box>
                <Typography variant="overline" sx={{ color: colors.primary.main, fontWeight: 700, letterSpacing: 1.2 }}>
                  LIVE ARENA
                </Typography>
                <Typography variant="h4" className="slot-hero-title">
                  3-SlotBET
                </Typography>
              </Box>
            </Stack>

            <Typography variant="body1" sx={{ color: colors.slate[600], maxWidth: 520, lineHeight: 1.6, mb: 2 }}>
              Spin the reels, match the symbols and win progressive jackpots. Simple gameplay with transparent on-chain results.
            </Typography>

            <Stack direction="row" gap={1.5} flexWrap="wrap" sx={{ gap: 1 }}>
              <CommonChip
                icon={<InstantIcon sx={{ fontSize: 16 }} />}
                label="3-Reel Slot"
                variant="neutral"
                size="small"
              />
              <CommonChip
                icon={<SparkleIcon sx={{ fontSize: 15 }} />}
                label="Progressive Jackpot"
                variant="neutral"
                size="small"
              />
              <CommonChip
                icon={<VerifiedIcon sx={{ fontSize: 15 }} />}
                label="On-Chain Results"
                variant="neutral"
                size="small"
              />
            </Stack>
          </Grid>

          <Grid item xs={12} md={5}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent={{ md: "flex-end" }}>
              <Box className="slot-stat-card" sx={{ minWidth: 140 }}>
                <Typography variant="caption" sx={{ color: colors.slate[500], fontWeight: 600, textTransform: "uppercase" }}>
                  Active Slots
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 800, color: colors.slate[900], my: 0.25 }}>
                  {totalActive}
                </Typography>
                <Typography variant="caption" sx={{ color: colors.emerald[600], fontWeight: 600 }}>
                  Ready to Play
                </Typography>
              </Box>

              <Box className="slot-stat-card" sx={{ minWidth: 160 }}>
                <Typography variant="caption" sx={{ color: colors.slate[500], fontWeight: 600, textTransform: "uppercase" }}>
                  Total Jackpot
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 800, color: colors.primary.main, my: 0.25 }}>
                  {combinedPrize} <Box component="span" sx={{ fontSize: "1rem", fontWeight: 700 }}>{currency}</Box>
                </Typography>
                <Typography variant="caption" sx={{ color: colors.slate[500], fontWeight: 500 }}>
                  Across all slots
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default SlotHeroBanner;